import React from 'react';
import { CardTier } from '../../types';
import './TierIndicator.css';

interface TierIndicatorProps {
  tier: CardTier;
  usageCount: number;
  animatingIndex?: number; // Index of asterisk currently animating (0-based)
}

interface AsteriskProps {
  filled: boolean;
  animating?: boolean;
}

const UNFILLED_COLOR = "#c8c4c0"; // Light gray for unfilled
const FILL_COLOR = "#7c9885"; // Teal matching card headers

const HandDrawnAsterisk: React.FC<AsteriskProps> = ({ filled, animating }) => {
  const isFilled = filled || animating;
  const strokeColor = isFilled ? FILL_COLOR : UNFILLED_COLOR;
  const fillColor = isFilled ? FILL_COLOR : "none";

  return (
    <svg
      className={`tier-asterisk ${filled ? 'filled' : ''} ${animating ? 'animating' : ''}`}
      viewBox="0 0 24 24"
      width="16"
      height="16"
    >
      <g
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        fill={fillColor}
      >
        <line x1="12" y1="3" x2="12" y2="21" />
        <line x1="3" y1="12" x2="21" y2="12" />
        <line x1="5" y1="5" x2="19" y2="19" />
        <line x1="19" y1="5" x2="5" y2="19" />
        {isFilled && <circle cx="12" cy="12" r="3" fill={fillColor} />}
      </g>
    </svg>
  );
};

const TierIndicator: React.FC<TierIndicatorProps> = ({ tier, usageCount, animatingIndex }) => {
  if (tier === 'tier_3') {
    return null;
  }

  const totalAsterisks = tier === 'basic' ? 3 : 5;
  const filledCount = Math.min(usageCount, totalAsterisks);

  return (
    <div className="tier-indicator">
      {Array.from({ length: totalAsterisks }, (_, i) => (
        <HandDrawnAsterisk
          key={i}
          filled={i < filledCount}
          animating={animatingIndex === i}
        />
      ))}
    </div>
  );
};

export default TierIndicator;
